<template>
  <div class="bea-preview">
    <div class="preview-viewer">
      <div v-if="template == null || !template.pages || bindings == null" class="preview-image">
        <img :src="imgPdf" alt="preview" />
      </div>
      <div v-else-if="isNotValid()" class="preview-image">
        <img :src="imgErrorTemplate" alt="preview" />
      </div>
      <pui-svg-signage-preview
        ref="preview"
        v-else
        :autosize="autosize"
        :bindings="bindings"
        :types="types"
        :template="template"
        :showAllPrintables="showAllPrintables"
        :showPage="showPage"
        class="preview-image-auto"
      />
    </div>
    <div v-if="showTools" class="preview-tool">
      <pui-switcher
        v-if="template != null && bindings != null"
        v-model="showAllPrintables"
        :label="$t('poster.document_viewer.show_all_printables.label')"
      />
    </div>
  </div>
</template>
<script>
import { TemplatesManager } from 'piivo-poster-engine/src/lib/services/templatesManager';

import imgErrorTemplate from '../static/img/error-template.jpg';
import imgPdf from '../static/img/pdf.jpg';

export default {
  name: 'puiDocumentViewer',
  props: {
    template: {
      type: Object,
      required: false,
    },
    bindings: {
      type: Object,
      required: false,
    },
    types: {
      type: Object,
      required: false,
    },
    showTools: {
      type: Boolean,
      default: true,
    },
    showPage: {
      type: Boolean,
      default: true,
    },
    /**
     * If the viewer should detect resizing of the parent element
     * and resize the svg in proportion.
     */
    autosize: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      isEditing: false,
      showAllPrintables: true,
      imgErrorTemplate,
      imgPdf,
    };
  },
  methods: {
    /**
     * @returns {Element} the main svg element of the poster
     */
    getSvgEl() {
      return this.$refs.preview ? this.$refs.preview.getSvgEl() : null;
    },
    /**
     * @returns {object} the template
     */
    getTemplate() {
      return this.template;
    },
    /**
     * Gets template validity flag.
     */
    isNotValid() {
      // Verifiy if the template hasn't prerequisites
      return TemplatesManager.isNotCorrect(this.template.computedTemplate);
    },
    // Exposed
    /**
     * Sets showAllPrintables from the outside
     * Example: show all printables to render svg/thumbnail
     */
    setShowAllPrintables(showAllPrintables) {
      this.showAllPrintables = showAllPrintables;
    },
  },
  /**
   * Before update hook.
   */
  beforeUpdate() {
    // Call a global method to init all parents and ids
    if (this.template !== null) {
      TemplatesManager.initProperties(this.template, this.bindings);
    }
  },
};
</script>
